import { render } from "./LeaveBulkActionModal.vue?vue&type=template&id=322b5550&scoped=true"
import script from "./LeaveBulkActionModal.vue?vue&type=script&lang=js"
export * from "./LeaveBulkActionModal.vue?vue&type=script&lang=js"

import "./LeaveBulkActionModal.vue?vue&type=style&index=0&id=322b5550&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322b5550"]])

export default __exports__